import {Reducer} from "redux";
import {Action, ActionType} from "../../actions";
import {FormData} from "../../state/ShoppingDiagnostics/FormData";

const updateFormData: Reducer<FormData> = (state: FormData = new FormData(), action: Action<ActionType, FormData>) => {
  switch (action.type) {
    case ActionType.SHOPPING_DIAGNOSTICS_FORM_AVAILABILITY_UPDATED:
      return { ...state, availabilityRequest: { ...state.availabilityRequest, ...action.data } };
    case ActionType.SHOPPING_DIAGNOSTICS_CORRELATION_ID_UPDATED:
      return { ...state, ...action.data};
    case ActionType.SHOPPING_DIAGNOSTICS_FORM_SIMULATEDINSTANT_UPDATED:
      return { ...state, simulatedInstant: action.data };
    case ActionType.SHOPPING_DIAGNOSTICS_FORM_IDENTITY_UPDATED:
      return { ...state, identity: action.data };
    case ActionType.SHOPPING_DIAGNOSTICS_FORM_DATA_VALIDATED:
      return { ...state, validation: action.data };
    case ActionType.SHOPPING_DIAGNOSTICS_HISTORICAL_DATA_VALIDATED:
      return {...state, historicalValidation: action.data}
    case ActionType.SHOPPING_DIAGNOSTICS_FORM_RESET:
      return new FormData(action.data);
    default:
      return state;
  }
};

export default updateFormData;
